/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getAirlines } from "api/services/common";
import { IAirlineOption } from "types/Common";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetAirlines(airportQuery: string, options?: UseQueryOptions<IAirlineOption[]> ) {
  return useQuery({
    queryKey: commonQueryKeys.airlines(airportQuery),
    queryFn: () => getAirlines(airportQuery).then((res) => res.data.results),
    refetchOnMount: false,
    enabled: airportQuery.length >= 2,
    staleTime: 60 * 1000, // 1 minute
    ...options,
  });
}
